
import { FC } from 'react';
import './DeleteActionRenderer.scss';
import { ICellRendererParams } from 'ag-grid-community';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';

interface DeleteActionParams extends ICellRendererParams {
    onActionClick(action: string, entityId: string): void;
    subject: string
}

const DeleteActionRenderer: FC<DeleteActionParams> = ({subject, data, onActionClick}) => {
    return <div className="action-renderer-cell">
        <Tooltip title={`Delete ${subject}`}>
            <DeleteOutlineOutlined onClick={() => onActionClick('delete', data.id)} />
        </Tooltip>
    </div>
};

export default DeleteActionRenderer;